import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../config'

export async function getRoles() {
    const response = await axios(REACT_APP_API_ABM_FW + '/roles/getAllforCombo')

    const data = response?.data?.data.map(item => {
        return { value: item.id, label: item.name }
    })

    return data || []
}
